"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _reactResponsive = require("react-responsive");

var _Modal = require("../../../../../Modal");

var _StyledLayout = require("../../../../../StyledLayout");

var _StyledTypography = require("../../../../../StyledTypography");

var _CarouselArrow = require("../../../../common/components/CarouselArrow");

var _helpers = require("../../../../../../lib/helpers");

var _Elements = require("./Elements");

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GridModal = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _folders, _folders2, _containingFolder$pho3, _containingFolder$pho4;

  var folders = _ref.folders,
      imgClickId = _ref.imgClickId,
      imgClickFolderId = _ref.imgClickFolderId,
      imgClickTimes = _ref.imgClickTimes,
      colour = _ref.colour,
      webpSupported = _ref.webpSupported;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      sliderIndex = _useState2[0],
      setSliderIndex = _useState2[1];

  var _useState3 = (0, _react.useState)(imgClickFolderId),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      currentFolderId = _useState4[0],
      setCurrentFolderId = _useState4[1];

  var sliderBoxRef = (0, _react.useRef)(null);
  var sliderRef = (0, _react.useRef)(null);
  var isMobileLandScape = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 667px)'
  });
  var currentGalleryIndex = folders.findIndex(function (item) {
    return item.id === currentFolderId;
  });
  var nextGalleryId = folders.length - 1 > currentGalleryIndex ? (_folders = folders[currentGalleryIndex + 1]) === null || _folders === void 0 ? void 0 : _folders.id : undefined;
  var prevGalleryId = currentGalleryIndex !== 0 ? (_folders2 = folders[currentGalleryIndex - 1]) === null || _folders2 === void 0 ? void 0 : _folders2.id : undefined; // NOTE: combine all folder's photo to an array
  // Probably expensive enough to memoize

  var allSlidePhotos = (0, _react.useMemo)(function () {
    return folders.reduce(function (acc, folder) {
      var _folder$photos;

      var photos = (folder === null || folder === void 0 ? void 0 : (_folder$photos = folder.photos) === null || _folder$photos === void 0 ? void 0 : _folder$photos.edges) || [];
      var newPhotos = photos.map(function (photo) {
        if (photo !== null && photo !== void 0 && photo.node) {
          var _photo$node, _photo$node2, _photo$node3, _photo$node3$images, _photo$node4, _photo$node5;

          return {
            height: photo === null || photo === void 0 ? void 0 : (_photo$node = photo.node) === null || _photo$node === void 0 ? void 0 : _photo$node.height,
            width: photo === null || photo === void 0 ? void 0 : (_photo$node2 = photo.node) === null || _photo$node2 === void 0 ? void 0 : _photo$node2.width,
            url: photo === null || photo === void 0 ? void 0 : (_photo$node3 = photo.node) === null || _photo$node3 === void 0 ? void 0 : (_photo$node3$images = _photo$node3.images) === null || _photo$node3$images === void 0 ? void 0 : _photo$node3$images[0].url,
            id: photo === null || photo === void 0 ? void 0 : (_photo$node4 = photo.node) === null || _photo$node4 === void 0 ? void 0 : _photo$node4.id,
            folderId: photo === null || photo === void 0 ? void 0 : (_photo$node5 = photo.node) === null || _photo$node5 === void 0 ? void 0 : _photo$node5.folderId
          };
        }

        return null;
      });
      return [].concat((0, _toConsumableArray2["default"])(acc), (0, _toConsumableArray2["default"])(newPhotos));
    }, []);
  }, [folders]);
  var containingFolder = (0, _react.useMemo)(function () {
    return folders.find(function (folder) {
      return (folder === null || folder === void 0 ? void 0 : folder.id) === currentFolderId;
    });
  }, [currentFolderId, folders]);
  var photoInFolderPosition = // eslint-disable-next-line max-len
  (0, _react.useMemo)(function () {
    var _containingFolder$pho, _containingFolder$pho2;

    return containingFolder === null || containingFolder === void 0 ? void 0 : (_containingFolder$pho = containingFolder.photos) === null || _containingFolder$pho === void 0 ? void 0 : (_containingFolder$pho2 = _containingFolder$pho.edges) === null || _containingFolder$pho2 === void 0 ? void 0 : _containingFolder$pho2.findIndex(function (photo) {
      var _photo$node6, _allSlidePhotos$slide;

      return (photo === null || photo === void 0 ? void 0 : (_photo$node6 = photo.node) === null || _photo$node6 === void 0 ? void 0 : _photo$node6.id) === ((_allSlidePhotos$slide = allSlidePhotos[sliderIndex]) === null || _allSlidePhotos$slide === void 0 ? void 0 : _allSlidePhotos$slide.id);
    });
  }, [allSlidePhotos, containingFolder, sliderIndex]);
  var imgClickIndex = allSlidePhotos.findIndex(function (photo) {
    return photo.id === imgClickId;
  });
  (0, _react.useEffect)(function () {
    if (imgClickIndex !== -1) {
      var _sliderRef$current;

      setSliderIndex(imgClickIndex); // eslint-disable-next-line no-unused-expressions

      sliderRef === null || sliderRef === void 0 ? void 0 : (_sliderRef$current = sliderRef.current) === null || _sliderRef$current === void 0 ? void 0 : _sliderRef$current.slickGoTo(imgClickIndex);
    }
  }, [imgClickIndex, imgClickTimes]);
  (0, _react.useEffect)(function () {
    setCurrentFolderId(imgClickFolderId);
  }, [imgClickFolderId, imgClickTimes]);

  var keyDownHandler = function keyDownHandler(event) {
    var _sliderRef$current2, _sliderRef$current3;

    switch (event.code) {
      case 'ArrowRight':
        // eslint-disable-next-line no-unused-expressions
        sliderRef === null || sliderRef === void 0 ? void 0 : (_sliderRef$current2 = sliderRef.current) === null || _sliderRef$current2 === void 0 ? void 0 : _sliderRef$current2.slickNext();
        break;

      case 'ArrowLeft':
        // eslint-disable-next-line no-unused-expressions
        sliderRef === null || sliderRef === void 0 ? void 0 : (_sliderRef$current3 = sliderRef.current) === null || _sliderRef$current3 === void 0 ? void 0 : _sliderRef$current3.slickPrev();
        break;

      default:
        break;
    }
  };

  (0, _react.useEffect)(function () {
    window.addEventListener('keydown', keyDownHandler);
    return function () {
      window.removeEventListener('keydown', keyDownHandler);
    };
  }, []);
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: sliderIndex !== 0 ? /*#__PURE__*/_react["default"].createElement(_CarouselArrow.PrevArrow, {
      transparentBg: !!isMobileLandScape,
      colour: colour
    }) : null,
    nextArrow: sliderIndex !== allSlidePhotos.length - 1 ? /*#__PURE__*/_react["default"].createElement(_CarouselArrow.NextArrow, {
      transparentBg: !!isMobileLandScape,
      colour: colour
    }) : null
  };

  var photoInfo = /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_StyledTypography.Paragraph, {
    portfolioFontFamily: true,
    portfolioForeground1: true,
    mr: "md"
  }, containingFolder === null || containingFolder === void 0 ? void 0 : containingFolder.name), /*#__PURE__*/_react["default"].createElement(_StyledTypography.Paragraph, {
    portfolioFontFamily: true,
    portfolioForeground1: true
  }, photoInFolderPosition + 1, " / ", containingFolder === null || containingFolder === void 0 ? void 0 : (_containingFolder$pho3 = containingFolder.photos) === null || _containingFolder$pho3 === void 0 ? void 0 : (_containingFolder$pho4 = _containingFolder$pho3.edges) === null || _containingFolder$pho4 === void 0 ? void 0 : _containingFolder$pho4.length));

  var customTitleContent = /*#__PURE__*/_react["default"].createElement(_Elements.StyledTitleBox, null);

  return /*#__PURE__*/_react["default"].createElement(_Modal.Modal, {
    ref: ref,
    fullWidth: true,
    fullHeight: true,
    fullScreen: true,
    fullScreenHeight: true,
    infiniteScroll: true,
    customTitle: customTitleContent,
    titleRightContent: photoInfo
  }, /*#__PURE__*/_react["default"].createElement(_Elements.SliderBox, {
    ref: sliderBoxRef
  }, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], (0, _extends2["default"])({
    ref: sliderRef
  }, settings, {
    beforeChange: function beforeChange(oldIndex, newIndex) {
      var _containingFolder$pho5, _containingFolder$pho6;

      if (oldIndex > newIndex) {
        if (photoInFolderPosition === 0 && prevGalleryId) {
          setCurrentFolderId(prevGalleryId);
        }
      } else if (photoInFolderPosition === (containingFolder === null || containingFolder === void 0 ? void 0 : (_containingFolder$pho5 = containingFolder.photos) === null || _containingFolder$pho5 === void 0 ? void 0 : (_containingFolder$pho6 = _containingFolder$pho5.edges) === null || _containingFolder$pho6 === void 0 ? void 0 : _containingFolder$pho6.length) - 1 && nextGalleryId) {
        setCurrentFolderId(nextGalleryId);
      }
    },
    afterChange: function afterChange(index) {
      setSliderIndex(index);
    }
  }), allSlidePhotos.map(function (image) {
    var portraitImageWidth = (window.innerHeight - 72) * image.width / image.height;
    var isLandscapeImage = image.width > image.height;

    var renderedImage = /*#__PURE__*/_react["default"].createElement(_Elements.Image, {
      alt: "",
      src: (0, _helpers.getImageByFormat)(image, webpSupported),
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      }
    });

    return /*#__PURE__*/_react["default"].createElement(_Elements.SliderItemBox, {
      key: (image === null || image === void 0 ? void 0 : image.id) || (image === null || image === void 0 ? void 0 : image.url)
    }, isLandscapeImage ? /*#__PURE__*/_react["default"].createElement(_Elements.LandscapeImageWrapper, null, renderedImage) : /*#__PURE__*/_react["default"].createElement(_Elements.PortraitImageWrapper, {
      width: portraitImageWidth
    }, renderedImage));
  }))));
});
GridModal.defaultProps = {
  colour: '',
  imgClickTimes: 0,
  webpSupported: false
};
GridModal.propTypes = {
  folders: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired,
  imgClickId: _propTypes["default"].string.isRequired,
  imgClickFolderId: _propTypes["default"].string.isRequired,
  imgClickTimes: _propTypes["default"].number,
  colour: _propTypes["default"].string,
  webpSupported: _propTypes["default"].bool
};
var _default = GridModal;
exports["default"] = _default;